import React from 'react';
import { defineMessages } from 'react-intl';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';
import { PFE_ICONS } from 'constants/icons';
import LINKS from 'constants/links';
import Message from 'components/Message';
import { Card, CardTitle } from 'components/Card';

import './HowSmartSpotWorks.scss';

const { block, element } = bem('how-smart-spot-works');

const messages = defineMessages({
  title: {
    id: 'smart-tools.how-smart-spot-works.title',
    defaultMessage: 'How SmartSpot works',
  },
  whyUtilizeTitle: {
    id: 'smart-tools.how-smart-spot-works.why-utilize-title',
    defaultMessage: 'Why utilize SmartSpot?',
  },
  automaticallyManages: {
    id: 'smart-tools.how-smart-spot-works.automatically-manages',
    defaultMessage: 'Automatically manages class availability',
  },
  protectDirectClients: {
    id: 'smart-tools.how-smart-spot-works.protect-direct-clients',
    defaultMessage: 'Protect direct clients',
  },
  maximizeEarnings: {
    id: 'smart-tools.how-smart-spot-works.maximize-earnings',
    defaultMessage: 'Maximize your earning potential',
  },
  learnMore: {
    id: 'smart-tools.how-smart-spot-works.learn-more',
    defaultMessage: 'Learn more',
  },
});

const HowSmartSpotWorks = ({ handleLearnMore }) => {
  const benefits = [
    {
      id: 'automatically-manages',
      icon: PFE_ICONS.manageClass,
      message: messages.automaticallyManages,
    },
    {
      id: 'protect-direct-clients',
      icon: PFE_ICONS.shieldCheck,
      message: messages.protectDirectClients,
    },
    {
      id: 'maximize-earnings',
      icon: PFE_ICONS.earningPotential,
      message: messages.maximizeEarnings,
    },
  ];

  return (
    <Card className={block()}>
      <div className={element('responsive-container')}>
        <div className={element('left-section')}>
          <CardTitle>
            <Message message={messages.title} />
          </CardTitle>

          <div className={element('video-container')}>
            <div className={element('video-embed')}>
              <iframe
                src="https://player.vimeo.com/video/1007792326?h=e38d3f2825&badge=0&autopause=0&player_id=0&app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                title="How ClassPass SmartTools Work – Become a Partner Today"
              />
              <script src="https://player.vimeo.com/api/player.js" />
            </div>
          </div>
        </div>

        <div className={element('benefits-section')}>
          <Message as="h3" className={element('benefits-title')} message={messages.whyUtilizeTitle} />
          <ul className={element('benefits-list')}>
            {benefits.map(benefit => (
              <li key={benefit.id} className={element('benefit-item')}>
                <div className={element('benefit-icon')}>
                  <Isvg src={benefit.icon} />
                </div>
                <Message className={element('benefit-text')} message={benefit.message} />
              </li>
            ))}
          </ul>

          <Message
            as="a"
            href={LINKS.smartspot.learnMore}
            className={element('learn-more-link')}
            message={messages.learnMore}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleLearnMore('how_ss_works')}
          />
        </div>
      </div>
    </Card>
  );
};

HowSmartSpotWorks.propTypes = {
  handleLearnMore: PropTypes.func.isRequired,
};

export default HowSmartSpotWorks;
